// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MainLayoutSidebar as Orders__MainLayoutSidebar } from "../Orders/MainLayoutSidebar.js";
import { MainLayoutHeader as Orders__MainLayoutHeader } from "../Orders/MainLayoutHeader.js";
import { MatButtonModule } from "@angular/material/button";

interface Properties {
    screenTitle: string;
    isForExternalUser: boolean;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-MainLayout',
    templateUrl: './MainLayout.html',
    styleUrls: ['./MainLayout.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        MatSidenavModule,
        MatToolbarModule,
        MatIconModule,
        Orders__MainLayoutSidebar,
        Orders__MainLayoutHeader,
        MatButtonModule
    ],
})
export class MainLayout extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.MainLayout';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    sidebar_206 = linkedSignal<boolean>(() => {
        const { screen, app } = this
        if (screen.isForExternalUser) return false
        if (Sys.Layout.isHandset) return false
        const sessionKey = 'sidebar_isOpen'
        if (sessionKey) return sessionStorage.getItem(sessionKey) !== 'false'
        return true
    });
    $validators: Record<number, ValidationRules> = {

    };
    input_screenTitle = input(undefined, { alias: 'screenTitle' });
    var_screenTitle = proxySignal<string>(undefined as any);
    input_isForExternalUser = input(undefined, { alias: 'isForExternalUser' });
    var_isForExternalUser = proxySignal<boolean>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get screenTitle() { return component.var_screenTitle() },
                set screenTitle(value: string) { component.var_screenTitle.set(value) },
                get isForExternalUser() { return component.var_isForExternalUser() },
                set isForExternalUser(value: boolean) { component.var_isForExternalUser.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            screenTitle: this.screen.screenTitle,
            isForExternalUser: this.screen.isForExternalUser
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_screenTitle = this.dialogData?.data?.screenTitle ?? this.input_screenTitle() ?? (undefined)
            if (new_screenTitle !== undefined) this.screen.screenTitle = new_screenTitle


            const new_isForExternalUser = this.dialogData?.data?.isForExternalUser ?? this.input_isForExternalUser() ?? (false)
            if (new_isForExternalUser !== undefined) this.screen.isForExternalUser = new_isForExternalUser

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    toggle_sidebar_206(isOpen?: boolean) {
        if (isOpen === undefined) isOpen = !this.sidebar_206()
        this.sidebar_206.set(isOpen)
        const key = 'sidebar_isOpen'
        if (key) sessionStorage.setItem(key, isOpen.toString())
    }

    async handler_ButtonBlock_179_click_assignToMyself_0($event: any, $scope: any): Promise<void> {
        let { $disabled }: { $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                await this.action_assignToMyself($event)
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            if (!screen.screenTitle) screen.screenTitle = Sys.Process.currentTaskDetails?.taskName || ''
            Sys.App.title = screen.screenTitle
        }
    }

    async action_assignToMyself($event?: any) {
        const { app, screen, output } = this
        {
            await Sys.Process.assignCurrentTaskToCurrentUser()
        }
    }
}
